var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("The page you are looking for was not found.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back to Meal Planner")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }